export const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
export const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
